import { colorMiscGray80 } from "@rhumbix/rmbx_design_system_design_tokens";
import React from "react";
import styled from "styled-components";
/**
 * This custom Option is designed to be passed to a selector. It allows the display of a main label that is used as the title
 * of the option, followed by any number of other strings that provide details.
 *
 * @param option An object that contains the key "option" and one value, which should match TitleAndDetailsSelectorOptionProps:
 *          value is its value in the selector, title is the main text, and details is an array of additional strings that can be
 *          displayed under the title
 * @returns The option to render in the selector
 */
export const TitleAndDetailsSelectorOption = (props) => {
    const { customContent } = props;
    const title = customContent.title ?? "";
    const details = customContent.details ?? [];
    return (React.createElement(OptionContainer, null,
        React.createElement(OptionTitle, null, title),
        details
            ? details.map((detailLine, index) => (React.createElement(OptionDetail, { key: index }, detailLine)))
            : null));
};
const OptionContainer = styled.div `
    display: flex;
    flex-direction: column;
    width: 100%;
`;
const OptionTitle = styled.div `
    color: ${colorMiscGray80};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 4px;
`;
const OptionDetail = styled.div `
    color: ${colorMiscGray80};
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 4px;
`;
export default TitleAndDetailsSelectorOption;
